// Using deployed Cloudflare Workers API for both development and production
const API_URL = 'https://watertrace-api.watertrace.workers.dev';
  
export default API_URL;